import { createSlice } from '@reduxjs/toolkit';
import { getInitialStartTime } from '../../utils/programUtils';

const initialState = {
    accountId: '',
    patchInformation: {},
    modalities: [],
    updating: false,
    patientName: '',
    program: {},
    device: {
        deviceId: 1,
        deviceModalityId: 0,
        lowerLimit: 0,
        upperLimit: 0,
        targetValue: 0,
        isAlarmActive: false,
        startTime: getInitialStartTime(),
        frequency: 1,
        interval: "Day",
        readingType: "Automated",
        isContinuous: false
    }
};

const modalityInfo = {
    deviceId: '',
    deviceModalityId: '',
    upperLimit: 0,
    lowerLimit: 0,
    targetValue: 0,
    isAlarmActive: false,
    isContinuous: false,
    startTime: getInitialStartTime(),
    frequency: 1,
    interval: "Day"
};

const updatePatchSlice = createSlice({
    name: 'updatePatch',
    initialState,
    reducers: {
        setFieldValue: (state, action) => {
            Object.entries(action.payload).forEach(([key, value]) => {
                if (state.hasOwnProperty(key)) {
                    state[key] = value;
                }
            });
        },
        setFormValue: (state, action) => {
            const { name, value } = action.payload;
            state[name] = value;
        },
        resetUpdatePatch: (state) => {
            Object.assign(state, initialState);
        },
        setDevice : (state, action) => {
            const { deviceId, ...rest } = action.payload;
            const updatedDevice = { ...state.device, ...rest };
            state.device = updatedDevice;
        },
        setUpdating : (state, action) => {
            const patientName = action.payload;
            state.updating = true;
            state.patientName = patientName;
        },
        resetModalities: (state) => {
            state.modalities = state.patchInformation?.modalities.map((m)=>{
                return {
                    ...modalityInfo,
                    deviceId: state.device.deviceId,
                    deviceModalityId: m.deviceModalityId
                }
            })
        },
        setSerialNumber : (state, action) => {
            const {serial, id, serialId} = action.payload;
           
            let updatedDevice = {...state.device};
            updatedDevice = {
                ...updatedDevice,
                serialNumber: serial,
                serialNumberId: serialId
            }
            state.device = updatedDevice;
            
        },
        setModality : (state, action) => {
            const { deviceId, deviceModalityId, ...rest } = action.payload;
            const existingModalityIndex = state.modalities.findIndex(mod => (mod.deviceId === deviceId && mod.deviceModalityId === deviceModalityId));
            if (existingModalityIndex !== -1) {
                const updatedMod = state.modalities.map((mod, index) => 
                    index === existingModalityIndex ? { ...mod, ...rest} : mod
                )
                return { ...state, modalities: updatedMod };
            } else {
                const newModality = { deviceId: deviceId, deviceModalityId: deviceModalityId, ...rest };
                return { ...state, modalities: [...state.modalities, newModality] };
            }
        },
        removeModality : (state, action) => {
            const deviceId = action.payload;
            const updatedModalities = state.modalities.filter(item => item.deviceId !== deviceId);
            state.modalities = updatedModalities;
        },
    },
});

export const {
    setFieldValue,
    setFormValue,
    resetUpdatePatch,
    resetModalities,
    setModality,
    removeModality,
    setDevice,
    setSerialNumber,
    setUpdating
} = updatePatchSlice.actions;

export default updatePatchSlice.reducer;
